import PropTypes from 'prop-types';
import React from 'react';
import { Menu, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import Logo from './../Logo';
import config from './../../../config/config.json';
import * as styles from './NavbarDesktop.less';

const { appHost } = config[process.env.REACT_APP_DIST_ENV];
const clearOffset = { margin: 0 };

const NavbarDesktop = ({ minimal = true }) => {
  return (
    <Menu secondary className={styles.navbarWrapper}>
      <Menu.Item className={styles.logoWrapper}>
        <Link to={`/`}>
          <Logo size='large' />
        </Link>
      </Menu.Item>
      {/* {navbarLinks.map(option => (
        <Item {...option} key={option.value} className={styles.navbarText} />
      ))} */}
      <Menu.Menu position='right'>
        {minimal ? (
          <div className={styles.linkWrapper}>
            {/* <span className={styles.linkText}>
              Already have an account?{' '}
              <a
                style={{ cursor: 'pointer' }}
                onClick={() => window.location.replace(`${appHost}/login`)}
              >
                Login here >
              </a>
            </span> */}
          </div>
        ) : (
          <>
            {/* <Menu.Item style={clearOffset}>
              <img src={searchIcon} className={styles.searchIcon} />
            </Menu.Item> */}
            <Menu.Item style={{ ...clearOffset, paddingRight: '0' }}>
              <Button
                secondary
                content='Log in'
                style={{ width: window.screen.width < 425 ? '90%' : 'auto' }}
                onClick={() => window.location.replace(`${appHost}/login`)}
              />
            </Menu.Item>
            {window.screen.width < 425 && <div style={{ marginTop: '20px' }} />}
            <Menu.Item style={clearOffset}>
              <Link to={`/signup`}>
                <Button
                  primary
                  content='Sign up'
                  style={{ width: window.screen.width < 425 ? '90%' : 'auto' }}
                />
              </Link>
            </Menu.Item>
          </>
        )}
      </Menu.Menu>
    </Menu>
  );
};

NavbarDesktop.propTypes = {
  minimal: PropTypes.bool,
  rightItems: PropTypes.arrayOf(PropTypes.object),
};

export default NavbarDesktop;



// WEBPACK FOOTER //
// ./src/views/components/Navbar/NavbarDesktop.js